<template>
  <ul class="tab_ul">
    <li :class="['tab_li', {'active_nav': navTabVal === item.value}]" v-for="(item, index) in navTabArr" :key="index" @click="emitFn(item, index)">
      {{currentAuthUser.corpUserId && item.change ? '我参与签/审的' : item.label}}（{{countFn(item.value)}}）
    </li>
  </ul>
</template>

<script>
  import {mapGetters} from "vuex";
  import { isInDingTalk } from '@/assets/js/utils/ding-env';
  export default {
    name: "navTab",
    props: {
      //tab类型：mySignList: 非成员的 (待签, 已结束)； corpSignList：成员的
      navTabArrType: {
        type: String,
      },
      //tab值
      navTabVal: {
        type: String,
      }
    },
    data() {
      return {
        activeNav: '',
      }
    },
    computed: {
      ...mapGetters(["currentAuthUser"]),
      signCountAll() {
        return this.$store.getters.getSignCountAll;
      },
      navTabArr() {
        //自己
        if (this.navTabArrType === 'mySignList') {
          return  [
            {label: '我参与签署的', value: 'corpMySign', change: true},
            {label: '我仅是发起人', value: 'mySendTo'},
          ];
        //  成员
        } else if (this.navTabArrType === 'corpSignList') {
          if (['5', '6'].includes(this.$route.query.signStatus)) {
            return []
            // return [
            //   {label: '文件审批', value: 'corpMySign'},
            //   {label: '用印审批', value: 'sealApprove'},
            // ];
          } else {
            return [
              {label: '我参与签署的', value: 'corpMySign', change: true},
              {label: '我仅是发起人', value: 'mySendTo'},
              {label: '抄送给我的', value: 'corpCcToMe'},
            ];
          }
        }
      },
    },
    methods: {
      countFn(val) {
        //signCountAll
        if (this.navTabArrType === 'mySignList') {
          switch (true) {
            case val === "corpMySign" && +this.$route.query.signStatus === 2:
              return this.signCountAll.noFinishCount || 0;
            case val === "corpMySign" && +this.$route.query.signStatus === 3:
              return this.signCountAll.finishCount || 0;
            case val === "mySendTo" && +this.$route.query.signStatus === 2:
              return this.signCountAll.myApplyNotSelfSignCount || 0;
            case val === "mySendTo" && +this.$route.query.signStatus === 3:
              return this.signCountAll.myFinishCount || 0;
            default:
              return ""
          }
        } else if (this.navTabArrType === 'corpSignList') {
          switch (true) {
            case val === "corpMySign" && +this.$route.query.signStatus === 3:
              return this.signCountAll.selfSignFinishCount || 0;
            case val === "mySendTo" && +this.$route.query.signStatus === 3:
              return this.signCountAll.myFinishCount || 0;
            case val === "corpCcToMe" && +this.$route.query.signStatus === 3:
              return this.signCountAll.ccToMeFinishCount || 0;
            case val === "corpMySign" && +this.$route.query.signStatus === 4:
              return this.signCountAll.noFinishCount || 0;
            case val === "mySendTo" && +this.$route.query.signStatus === 4:
              return this.signCountAll.myApplyNotSelfSignCount || 0;
            case val === "corpCcToMe" && +this.$route.query.signStatus === 4:
              return this.signCountAll.ccToMeSignCount || 0;
            case val === "corpMySign" && [5, 6].includes(+this.$route.query.signStatus):
              return this.signCountAll.approveCount || 0;
            case val === "sealApprove" && [5, 6].includes(+this.$route.query.signStatus):
              return this.signCountAll.approveSignCount || 0;
            default:
              return 0
          }
        }
      },
      emitFn(item, index) {
        if (['5', '6'].includes(this.$route.query.signStatus)) {
          if (item.value === 'corpMySign' && this.$route.query.signStatus !== '5') {
            this.$router.push({
              path: "/corp/signInfo/signList",
              query: { signStatus: 5 }
            })
          } else if(item.value === 'sealApprove' && this.$route.query.signStatus !== '6') {
            this.$router.push({
              path: "/corp/signInfo/sealApproval",
              query: { signStatus: 6 }
            })
          }
        } else {
          this.$emit('update:navTabVal', item.value);
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .tab_ul {
    display: flex;
    justify-content: flex-start;
    padding: 0 10px;
    .tab_li {
      text-align: center;
      padding: 10px 0;
      margin-right: 30px;
      font-weight: bold;
      font-size: 15px;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      &.active_nav {
        color: #ec1c1c;
        border-bottom: 2px solid #ec1c1c;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/nav-tab/navTab.vue